import posthog from "posthog-js";

export function getPostHogEnvironment(): string {
  return (
    import.meta.env.SERVER_TARGET || (import.meta.env.DEV ? "dev" : "production")
  );
}

export function setPostHogGroup(
  groupType: string,
  groupKey: string,
  properties: Record<string, unknown> = {}
): void {
  posthog.group(groupType, groupKey, {
    ...properties,
    environment: getPostHogEnvironment(),
  });
}
